class ShadeFinderQuizProductMatch extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupBackListeners()
    this.setupStartAgainListeners()
  }

  setupStartAgainListeners () {
    const startAgainBtns = document.querySelectorAll('[data-product-match-section-restart-trigger]')

    startAgainBtns.forEach(startAgainBtn => {
      startAgainBtn.addEventListener('click', () => {
        document.querySelector('shade-finder-quiz-product-match').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-start').classList.add('is-active')

        window.scrollTo(0, 0)
      })
    })
  }

  setupBackListeners () {
    const backBtns = document.querySelectorAll('[data-product-match-section-back-trigger]')
    const backBtnsModelfits = document.querySelectorAll('[data-modelfit-section-back-trigger]')

    backBtns.forEach(backBtn => {
      backBtn.addEventListener('click', () => {
        document.querySelector('shade-finder-quiz-product-match').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-modelfits').classList.add('is-active')

        const radioInputs = document.querySelectorAll('.sec-QuizContent_ModelBlockRadioInput')
        radioInputs.forEach(input => {
          input.checked = false
        })

        const continueBtns = document.querySelectorAll('[data-product-match-section-trigger]')
        continueBtns.forEach(continueBtn => {
          continueBtn.setAttribute('data-skintone-main-product', '')
          continueBtn.setAttribute('data-skintone-main-product-variant', '')
          continueBtn.setAttribute('disabled', '')
        })

        window.scrollTo(0, 0)
      })
    })

    backBtnsModelfits.forEach(backBtn => {
      backBtn.addEventListener('click', () => {
        document.querySelector('shade-finder-quiz-product-match').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-modelfits').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-skintone').classList.add('is-active')

        window.scrollTo(0, 0)
      })
    })
  }
}

if (!customElements.get('shade-finder-quiz-product-match')) {
  customElements.define('shade-finder-quiz-product-match', ShadeFinderQuizProductMatch)
}
